/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateCompany = /* GraphQL */ `
  subscription OnCreateCompany {
    onCreateCompany {
      id
      name
      premier
      email
      website
      phone
      phoneExt
      alertMessage
      IPCorp
      active
      updatedAt
      createdAt
      owner
      accounts {
        items {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        nextToken
      }
      persons {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      cases {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      hq {
        id
        name
        createdAt
        updatedAt
        owner
        IPCorp
        active
        companies {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
    }
  }
`;
export const onUpdateCompany = /* GraphQL */ `
  subscription OnUpdateCompany {
    onUpdateCompany {
      id
      name
      premier
      email
      website
      phone
      phoneExt
      alertMessage
      IPCorp
      active
      updatedAt
      createdAt
      owner
      accounts {
        items {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        nextToken
      }
      persons {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      cases {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      hq {
        id
        name
        createdAt
        updatedAt
        owner
        IPCorp
        active
        companies {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
    }
  }
`;
export const onDeleteCompany = /* GraphQL */ `
  subscription OnDeleteCompany {
    onDeleteCompany {
      id
      name
      premier
      email
      website
      phone
      phoneExt
      alertMessage
      IPCorp
      active
      updatedAt
      createdAt
      owner
      accounts {
        items {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        nextToken
      }
      persons {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      cases {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      hq {
        id
        name
        createdAt
        updatedAt
        owner
        IPCorp
        active
        companies {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
    }
  }
`;
export const onCreateAccount = /* GraphQL */ `
  subscription OnCreateAccount {
    onCreateAccount {
      id
      name
      nameLegal
      namePrevious
      status
      premier
      createdAt
      ownershipType
      processorId
      approvalDate
      underwritingStatus
      nameDba
      phoneBusiness
      phoneSupport
      phoneFax
      ein
      alert
      IPCorp
      addressMailing
      bankAccount
      addressPhysical
      accountCompanyId
      owner
      updatedAt
      company {
        id
        name
        premier
        email
        website
        phone
        phoneExt
        alertMessage
        IPCorp
        active
        updatedAt
        createdAt
        owner
        accounts {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        hq {
          id
          name
          createdAt
          updatedAt
          owner
          IPCorp
          active
        }
      }
      services {
        items {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        nextToken
      }
      products {
        items {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        nextToken
      }
      persons {
        items {
          id
          role
          title
          email
          business_email
          other_email
          ownership
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      cases {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onUpdateAccount = /* GraphQL */ `
  subscription OnUpdateAccount {
    onUpdateAccount {
      id
      name
      nameLegal
      namePrevious
      status
      premier
      createdAt
      ownershipType
      processorId
      approvalDate
      underwritingStatus
      nameDba
      phoneBusiness
      phoneSupport
      phoneFax
      ein
      alert
      IPCorp
      addressMailing
      bankAccount
      addressPhysical
      accountCompanyId
      owner
      updatedAt
      company {
        id
        name
        premier
        email
        website
        phone
        phoneExt
        alertMessage
        IPCorp
        active
        updatedAt
        createdAt
        owner
        accounts {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        hq {
          id
          name
          createdAt
          updatedAt
          owner
          IPCorp
          active
        }
      }
      services {
        items {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        nextToken
      }
      products {
        items {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        nextToken
      }
      persons {
        items {
          id
          role
          title
          email
          business_email
          other_email
          ownership
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      cases {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onDeleteAccount = /* GraphQL */ `
  subscription OnDeleteAccount {
    onDeleteAccount {
      id
      name
      nameLegal
      namePrevious
      status
      premier
      createdAt
      ownershipType
      processorId
      approvalDate
      underwritingStatus
      nameDba
      phoneBusiness
      phoneSupport
      phoneFax
      ein
      alert
      IPCorp
      addressMailing
      bankAccount
      addressPhysical
      accountCompanyId
      owner
      updatedAt
      company {
        id
        name
        premier
        email
        website
        phone
        phoneExt
        alertMessage
        IPCorp
        active
        updatedAt
        createdAt
        owner
        accounts {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        hq {
          id
          name
          createdAt
          updatedAt
          owner
          IPCorp
          active
        }
      }
      services {
        items {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        nextToken
      }
      products {
        items {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        nextToken
      }
      persons {
        items {
          id
          role
          title
          email
          business_email
          other_email
          ownership
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      cases {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onCreateService = /* GraphQL */ `
  subscription OnCreateService {
    onCreateService {
      id
      name
      nameLegal
      description
      pilot
      merchantNumber
      email
      website
      phone
      phoneExt
      status
      processorId
      approvalDate
      underwritingStatus
      IPCorp
      serviceType
      bankAccount
      addressPhysical
      addressMailing
      createdAt
      updatedAt
      isRestructured
      nameDba
      processor
      proposalStatementValue
      phoneBusiness
      phoneSupport
      phoneFax
      ein
      alertMessage
      ownershipType
      avgTrxAmount
      totalCashCreditSalesMonthly
      estAvgMcVisaTicketSaleAmount
      volumeMcVisaOutletMonthly
      dateUwResult
      dateContractExt
      uwResult
      dateOpen
      dateClosed
      businessType
      busSicCode
      busSicCodeDesc
      busProductsSold
      busSalesLimitM
      busTicketAvg
      busTicketMax
      busSwipePct
      busKeyPct
      busWebPct
      busMailPct
      busAgeY
      busAgeM
      busBusToBus
      busBusToCon
      busLocationCnt
      busSeasonOn
      busSeasonM
      busSeasonOpenM
      busSeasonCloseM
      amex
      amexNum
      discover
      discoverNum
      wexVoyagerOn
      wexVoyagerId
      esaId
      ebtFnsNum
      ebtCashOn
      checkServiceVendor
      checkServiceNum
      giftVendor
      giftVendorNum
      debitPinOn
      cashCreditSalesM
      mcVisaSaleAvg
      mcVisaVolM
      checksCntAvgM
      owner
      closeRequested
      closeDate
      closeReason
      closeReasonDetails
      closeEtfAmountRes
      closeCancelFee
      closeResReportDate
      closeEtfAmount
      closeEtfAdjust
      closeEtfRefundAmount
      closeEtfRefundDate
      closeEtfChargedDate
      closeEtfWaiveReason
      closeEtfWaiveOther
      closeResReportRefundDate
      beta
      pendingResponsibility
      dateSubmitted
      dateFirstProcessing
      declineReason
      declineNotes
      annualAmount
      annualAmountPCI
      altMonthMinAmount
      isWithdrawalAccount
      wbankName
      wbankRouting
      wbankAccount
      withdrawalAccount
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      portfolios {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      serviceProduct {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      products {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      cases {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      closeEtfWaiveAppover {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
    }
  }
`;
export const onUpdateService = /* GraphQL */ `
  subscription OnUpdateService {
    onUpdateService {
      id
      name
      nameLegal
      description
      pilot
      merchantNumber
      email
      website
      phone
      phoneExt
      status
      processorId
      approvalDate
      underwritingStatus
      IPCorp
      serviceType
      bankAccount
      addressPhysical
      addressMailing
      createdAt
      updatedAt
      isRestructured
      nameDba
      processor
      proposalStatementValue
      phoneBusiness
      phoneSupport
      phoneFax
      ein
      alertMessage
      ownershipType
      avgTrxAmount
      totalCashCreditSalesMonthly
      estAvgMcVisaTicketSaleAmount
      volumeMcVisaOutletMonthly
      dateUwResult
      dateContractExt
      uwResult
      dateOpen
      dateClosed
      businessType
      busSicCode
      busSicCodeDesc
      busProductsSold
      busSalesLimitM
      busTicketAvg
      busTicketMax
      busSwipePct
      busKeyPct
      busWebPct
      busMailPct
      busAgeY
      busAgeM
      busBusToBus
      busBusToCon
      busLocationCnt
      busSeasonOn
      busSeasonM
      busSeasonOpenM
      busSeasonCloseM
      amex
      amexNum
      discover
      discoverNum
      wexVoyagerOn
      wexVoyagerId
      esaId
      ebtFnsNum
      ebtCashOn
      checkServiceVendor
      checkServiceNum
      giftVendor
      giftVendorNum
      debitPinOn
      cashCreditSalesM
      mcVisaSaleAvg
      mcVisaVolM
      checksCntAvgM
      owner
      closeRequested
      closeDate
      closeReason
      closeReasonDetails
      closeEtfAmountRes
      closeCancelFee
      closeResReportDate
      closeEtfAmount
      closeEtfAdjust
      closeEtfRefundAmount
      closeEtfRefundDate
      closeEtfChargedDate
      closeEtfWaiveReason
      closeEtfWaiveOther
      closeResReportRefundDate
      beta
      pendingResponsibility
      dateSubmitted
      dateFirstProcessing
      declineReason
      declineNotes
      annualAmount
      annualAmountPCI
      altMonthMinAmount
      isWithdrawalAccount
      wbankName
      wbankRouting
      wbankAccount
      withdrawalAccount
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      portfolios {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      serviceProduct {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      products {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      cases {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      closeEtfWaiveAppover {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
    }
  }
`;
export const onDeleteService = /* GraphQL */ `
  subscription OnDeleteService {
    onDeleteService {
      id
      name
      nameLegal
      description
      pilot
      merchantNumber
      email
      website
      phone
      phoneExt
      status
      processorId
      approvalDate
      underwritingStatus
      IPCorp
      serviceType
      bankAccount
      addressPhysical
      addressMailing
      createdAt
      updatedAt
      isRestructured
      nameDba
      processor
      proposalStatementValue
      phoneBusiness
      phoneSupport
      phoneFax
      ein
      alertMessage
      ownershipType
      avgTrxAmount
      totalCashCreditSalesMonthly
      estAvgMcVisaTicketSaleAmount
      volumeMcVisaOutletMonthly
      dateUwResult
      dateContractExt
      uwResult
      dateOpen
      dateClosed
      businessType
      busSicCode
      busSicCodeDesc
      busProductsSold
      busSalesLimitM
      busTicketAvg
      busTicketMax
      busSwipePct
      busKeyPct
      busWebPct
      busMailPct
      busAgeY
      busAgeM
      busBusToBus
      busBusToCon
      busLocationCnt
      busSeasonOn
      busSeasonM
      busSeasonOpenM
      busSeasonCloseM
      amex
      amexNum
      discover
      discoverNum
      wexVoyagerOn
      wexVoyagerId
      esaId
      ebtFnsNum
      ebtCashOn
      checkServiceVendor
      checkServiceNum
      giftVendor
      giftVendorNum
      debitPinOn
      cashCreditSalesM
      mcVisaSaleAvg
      mcVisaVolM
      checksCntAvgM
      owner
      closeRequested
      closeDate
      closeReason
      closeReasonDetails
      closeEtfAmountRes
      closeCancelFee
      closeResReportDate
      closeEtfAmount
      closeEtfAdjust
      closeEtfRefundAmount
      closeEtfRefundDate
      closeEtfChargedDate
      closeEtfWaiveReason
      closeEtfWaiveOther
      closeResReportRefundDate
      beta
      pendingResponsibility
      dateSubmitted
      dateFirstProcessing
      declineReason
      declineNotes
      annualAmount
      annualAmountPCI
      altMonthMinAmount
      isWithdrawalAccount
      wbankName
      wbankRouting
      wbankAccount
      withdrawalAccount
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      portfolios {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      serviceProduct {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      products {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      cases {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      closeEtfWaiveAppover {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
    }
  }
`;
export const onCreatePortfolio = /* GraphQL */ `
  subscription OnCreatePortfolio {
    onCreatePortfolio {
      id
      name
      description
      premier
      status
      owner
      createdAt
      updatedAt
      services {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      reportPortfolios {
        items {
          id
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onUpdatePortfolio = /* GraphQL */ `
  subscription OnUpdatePortfolio {
    onUpdatePortfolio {
      id
      name
      description
      premier
      status
      owner
      createdAt
      updatedAt
      services {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      reportPortfolios {
        items {
          id
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onDeletePortfolio = /* GraphQL */ `
  subscription OnDeletePortfolio {
    onDeletePortfolio {
      id
      name
      description
      premier
      status
      owner
      createdAt
      updatedAt
      services {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      reportPortfolios {
        items {
          id
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onCreatePortfolioService = /* GraphQL */ `
  subscription OnCreatePortfolioService {
    onCreatePortfolioService {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      portfolio {
        id
        name
        description
        premier
        status
        owner
        createdAt
        updatedAt
        services {
          nextToken
        }
        reportPortfolios {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
    }
  }
`;
export const onUpdatePortfolioService = /* GraphQL */ `
  subscription OnUpdatePortfolioService {
    onUpdatePortfolioService {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      portfolio {
        id
        name
        description
        premier
        status
        owner
        createdAt
        updatedAt
        services {
          nextToken
        }
        reportPortfolios {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
    }
  }
`;
export const onDeletePortfolioService = /* GraphQL */ `
  subscription OnDeletePortfolioService {
    onDeletePortfolioService {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      portfolio {
        id
        name
        description
        premier
        status
        owner
        createdAt
        updatedAt
        services {
          nextToken
        }
        reportPortfolios {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
    }
  }
`;
export const onCreateReportPortfolios = /* GraphQL */ `
  subscription OnCreateReportPortfolios {
    onCreateReportPortfolios {
      id
      createdAt
      updatedAt
      owner
      portfolio {
        id
        name
        description
        premier
        status
        owner
        createdAt
        updatedAt
        services {
          nextToken
        }
        reportPortfolios {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onUpdateReportPortfolios = /* GraphQL */ `
  subscription OnUpdateReportPortfolios {
    onUpdateReportPortfolios {
      id
      createdAt
      updatedAt
      owner
      portfolio {
        id
        name
        description
        premier
        status
        owner
        createdAt
        updatedAt
        services {
          nextToken
        }
        reportPortfolios {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onDeleteReportPortfolios = /* GraphQL */ `
  subscription OnDeleteReportPortfolios {
    onDeleteReportPortfolios {
      id
      createdAt
      updatedAt
      owner
      portfolio {
        id
        name
        description
        premier
        status
        owner
        createdAt
        updatedAt
        services {
          nextToken
        }
        reportPortfolios {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onCreateProduct = /* GraphQL */ `
  subscription OnCreateProduct {
    onCreateProduct {
      id
      name
      description
      status
      billingMethod
      serial
      platform
      appType
      connect
      conversion
      encryptionKey
      purchaseSwap
      feeMonthly
      cashDiscount
      owner
      virtualTerminal
      accountVault
      recurring
      customerSignUp
      authNetEmulator
      multMerchantMultiDeposit
      multiMerchantNumber
      notesComments
      setupFee
      perItemFee
      feeMonthlyAmount
      terminalOrTsysId
      midV
      storeNumber
      url
      usernames
      gatewayId
      vendorContactNotes
      conversionSetupCost
      soldAmount
      warrantyReplacement
      replacementDate
      isPinPad
      pinPadPurchaseAmount
      FPPPinMonthlyFee
      pabx
      staticIp
      dns1
      gatewayIp
      subnet
      dns2
      secureFileCheck
      securityLevel
      tipLine
      counterTip
      serverNumer
      autoCloseTime
      giftCardProvider
      ebt
      avs
      checkProviderNumber
      fraud
      merchantNumber
      purchaseCard
      taxId
      downloadPhone
      portNumber
      deviceId
      emvSmartCard
      nfc
      autoClose
      giftCards
      internalPinPad
      checkServices
      cvv2
      multiMerchant
      invoiceNumber
      customerCode
      createdAt
      updatedAt
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      billToService {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      children {
        items {
          id
          parentId
          required
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      services {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      productOption {
        id
        name
        category
        brand
        legacyName
        status
        notes
        owner
        createdAt
        updatedAt
        products {
          nextToken
        }
        children {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      cases {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onUpdateProduct = /* GraphQL */ `
  subscription OnUpdateProduct {
    onUpdateProduct {
      id
      name
      description
      status
      billingMethod
      serial
      platform
      appType
      connect
      conversion
      encryptionKey
      purchaseSwap
      feeMonthly
      cashDiscount
      owner
      virtualTerminal
      accountVault
      recurring
      customerSignUp
      authNetEmulator
      multMerchantMultiDeposit
      multiMerchantNumber
      notesComments
      setupFee
      perItemFee
      feeMonthlyAmount
      terminalOrTsysId
      midV
      storeNumber
      url
      usernames
      gatewayId
      vendorContactNotes
      conversionSetupCost
      soldAmount
      warrantyReplacement
      replacementDate
      isPinPad
      pinPadPurchaseAmount
      FPPPinMonthlyFee
      pabx
      staticIp
      dns1
      gatewayIp
      subnet
      dns2
      secureFileCheck
      securityLevel
      tipLine
      counterTip
      serverNumer
      autoCloseTime
      giftCardProvider
      ebt
      avs
      checkProviderNumber
      fraud
      merchantNumber
      purchaseCard
      taxId
      downloadPhone
      portNumber
      deviceId
      emvSmartCard
      nfc
      autoClose
      giftCards
      internalPinPad
      checkServices
      cvv2
      multiMerchant
      invoiceNumber
      customerCode
      createdAt
      updatedAt
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      billToService {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      children {
        items {
          id
          parentId
          required
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      services {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      productOption {
        id
        name
        category
        brand
        legacyName
        status
        notes
        owner
        createdAt
        updatedAt
        products {
          nextToken
        }
        children {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      cases {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onDeleteProduct = /* GraphQL */ `
  subscription OnDeleteProduct {
    onDeleteProduct {
      id
      name
      description
      status
      billingMethod
      serial
      platform
      appType
      connect
      conversion
      encryptionKey
      purchaseSwap
      feeMonthly
      cashDiscount
      owner
      virtualTerminal
      accountVault
      recurring
      customerSignUp
      authNetEmulator
      multMerchantMultiDeposit
      multiMerchantNumber
      notesComments
      setupFee
      perItemFee
      feeMonthlyAmount
      terminalOrTsysId
      midV
      storeNumber
      url
      usernames
      gatewayId
      vendorContactNotes
      conversionSetupCost
      soldAmount
      warrantyReplacement
      replacementDate
      isPinPad
      pinPadPurchaseAmount
      FPPPinMonthlyFee
      pabx
      staticIp
      dns1
      gatewayIp
      subnet
      dns2
      secureFileCheck
      securityLevel
      tipLine
      counterTip
      serverNumer
      autoCloseTime
      giftCardProvider
      ebt
      avs
      checkProviderNumber
      fraud
      merchantNumber
      purchaseCard
      taxId
      downloadPhone
      portNumber
      deviceId
      emvSmartCard
      nfc
      autoClose
      giftCards
      internalPinPad
      checkServices
      cvv2
      multiMerchant
      invoiceNumber
      customerCode
      createdAt
      updatedAt
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      billToService {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      children {
        items {
          id
          parentId
          required
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      services {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      productOption {
        id
        name
        category
        brand
        legacyName
        status
        notes
        owner
        createdAt
        updatedAt
        products {
          nextToken
        }
        children {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      cases {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onCreateProductChild = /* GraphQL */ `
  subscription OnCreateProductChild {
    onCreateProductChild {
      id
      parentId
      required
      owner
      createdAt
      updatedAt
      esData
      esSync
      parent {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      child {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
    }
  }
`;
export const onUpdateProductChild = /* GraphQL */ `
  subscription OnUpdateProductChild {
    onUpdateProductChild {
      id
      parentId
      required
      owner
      createdAt
      updatedAt
      esData
      esSync
      parent {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      child {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
    }
  }
`;
export const onDeleteProductChild = /* GraphQL */ `
  subscription OnDeleteProductChild {
    onDeleteProductChild {
      id
      parentId
      required
      owner
      createdAt
      updatedAt
      esData
      esSync
      parent {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      child {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
    }
  }
`;
export const onCreateProductService = /* GraphQL */ `
  subscription OnCreateProductService {
    onCreateProductService {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      product {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
    }
  }
`;
export const onUpdateProductService = /* GraphQL */ `
  subscription OnUpdateProductService {
    onUpdateProductService {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      product {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
    }
  }
`;
export const onDeleteProductService = /* GraphQL */ `
  subscription OnDeleteProductService {
    onDeleteProductService {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      product {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
    }
  }
`;
export const onCreateProductOption = /* GraphQL */ `
  subscription OnCreateProductOption {
    onCreateProductOption {
      id
      name
      category
      brand
      legacyName
      status
      notes
      owner
      createdAt
      updatedAt
      products {
        items {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        nextToken
      }
      children {
        items {
          id
          parentId
          required
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onUpdateProductOption = /* GraphQL */ `
  subscription OnUpdateProductOption {
    onUpdateProductOption {
      id
      name
      category
      brand
      legacyName
      status
      notes
      owner
      createdAt
      updatedAt
      products {
        items {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        nextToken
      }
      children {
        items {
          id
          parentId
          required
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onDeleteProductOption = /* GraphQL */ `
  subscription OnDeleteProductOption {
    onDeleteProductOption {
      id
      name
      category
      brand
      legacyName
      status
      notes
      owner
      createdAt
      updatedAt
      products {
        items {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        nextToken
      }
      children {
        items {
          id
          parentId
          required
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onCreateProductOptionChild = /* GraphQL */ `
  subscription OnCreateProductOptionChild {
    onCreateProductOptionChild {
      id
      parentId
      required
      owner
      createdAt
      updatedAt
      esData
      esSync
      parent {
        id
        name
        category
        brand
        legacyName
        status
        notes
        owner
        createdAt
        updatedAt
        products {
          nextToken
        }
        children {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      child {
        id
        name
        category
        brand
        legacyName
        status
        notes
        owner
        createdAt
        updatedAt
        products {
          nextToken
        }
        children {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
    }
  }
`;
export const onUpdateProductOptionChild = /* GraphQL */ `
  subscription OnUpdateProductOptionChild {
    onUpdateProductOptionChild {
      id
      parentId
      required
      owner
      createdAt
      updatedAt
      esData
      esSync
      parent {
        id
        name
        category
        brand
        legacyName
        status
        notes
        owner
        createdAt
        updatedAt
        products {
          nextToken
        }
        children {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      child {
        id
        name
        category
        brand
        legacyName
        status
        notes
        owner
        createdAt
        updatedAt
        products {
          nextToken
        }
        children {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
    }
  }
`;
export const onDeleteProductOptionChild = /* GraphQL */ `
  subscription OnDeleteProductOptionChild {
    onDeleteProductOptionChild {
      id
      parentId
      required
      owner
      createdAt
      updatedAt
      esData
      esSync
      parent {
        id
        name
        category
        brand
        legacyName
        status
        notes
        owner
        createdAt
        updatedAt
        products {
          nextToken
        }
        children {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      child {
        id
        name
        category
        brand
        legacyName
        status
        notes
        owner
        createdAt
        updatedAt
        products {
          nextToken
        }
        children {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
    }
  }
`;
export const onCreatePerson = /* GraphQL */ `
  subscription OnCreatePerson {
    onCreatePerson {
      id
      given_name
      middle_name
      family_name
      nickname
      website
      email
      email_verified
      zoneinfo
      locale
      phone_number_verified
      phone_mobile
      phone_number
      phone_other
      phone_home
      fax_number
      addressHome
      addressOther
      ssn
      dob
      dl_number
      createdAt
      updatedAt
      description
      premier
      cognito_userid
      owner
      companys {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      accounts {
        items {
          id
          role
          title
          email
          business_email
          other_email
          ownership
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      cases {
        items {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      messages {
        items {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
    }
  }
`;
export const onUpdatePerson = /* GraphQL */ `
  subscription OnUpdatePerson {
    onUpdatePerson {
      id
      given_name
      middle_name
      family_name
      nickname
      website
      email
      email_verified
      zoneinfo
      locale
      phone_number_verified
      phone_mobile
      phone_number
      phone_other
      phone_home
      fax_number
      addressHome
      addressOther
      ssn
      dob
      dl_number
      createdAt
      updatedAt
      description
      premier
      cognito_userid
      owner
      companys {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      accounts {
        items {
          id
          role
          title
          email
          business_email
          other_email
          ownership
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      cases {
        items {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      messages {
        items {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
    }
  }
`;
export const onDeletePerson = /* GraphQL */ `
  subscription OnDeletePerson {
    onDeletePerson {
      id
      given_name
      middle_name
      family_name
      nickname
      website
      email
      email_verified
      zoneinfo
      locale
      phone_number_verified
      phone_mobile
      phone_number
      phone_other
      phone_home
      fax_number
      addressHome
      addressOther
      ssn
      dob
      dl_number
      createdAt
      updatedAt
      description
      premier
      cognito_userid
      owner
      companys {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      accounts {
        items {
          id
          role
          title
          email
          business_email
          other_email
          ownership
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      cases {
        items {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      messages {
        items {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
    }
  }
`;
export const onCreateSalesRep = /* GraphQL */ `
  subscription OnCreateSalesRep {
    onCreateSalesRep {
      id
      given_name
      family_name
      nickname
      website
      email
      email_verified
      zoneinfo
      locale
      phone_number
      phone_number_verified
      addressMailing
      description
      premier
      cognito_userid
      createdAt
      updatedAt
      owner
      cases {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onUpdateSalesRep = /* GraphQL */ `
  subscription OnUpdateSalesRep {
    onUpdateSalesRep {
      id
      given_name
      family_name
      nickname
      website
      email
      email_verified
      zoneinfo
      locale
      phone_number
      phone_number_verified
      addressMailing
      description
      premier
      cognito_userid
      createdAt
      updatedAt
      owner
      cases {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onDeleteSalesRep = /* GraphQL */ `
  subscription OnDeleteSalesRep {
    onDeleteSalesRep {
      id
      given_name
      family_name
      nickname
      website
      email
      email_verified
      zoneinfo
      locale
      phone_number
      phone_number_verified
      addressMailing
      description
      premier
      cognito_userid
      createdAt
      updatedAt
      owner
      cases {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onCreatePersonCompany = /* GraphQL */ `
  subscription OnCreatePersonCompany {
    onCreatePersonCompany {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      company {
        id
        name
        premier
        email
        website
        phone
        phoneExt
        alertMessage
        IPCorp
        active
        updatedAt
        createdAt
        owner
        accounts {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        hq {
          id
          name
          createdAt
          updatedAt
          owner
          IPCorp
          active
        }
      }
      person {
        id
        given_name
        middle_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number_verified
        phone_mobile
        phone_number
        phone_other
        phone_home
        fax_number
        addressHome
        addressOther
        ssn
        dob
        dl_number
        createdAt
        updatedAt
        description
        premier
        cognito_userid
        owner
        companys {
          nextToken
        }
        accounts {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        messages {
          nextToken
        }
      }
    }
  }
`;
export const onUpdatePersonCompany = /* GraphQL */ `
  subscription OnUpdatePersonCompany {
    onUpdatePersonCompany {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      company {
        id
        name
        premier
        email
        website
        phone
        phoneExt
        alertMessage
        IPCorp
        active
        updatedAt
        createdAt
        owner
        accounts {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        hq {
          id
          name
          createdAt
          updatedAt
          owner
          IPCorp
          active
        }
      }
      person {
        id
        given_name
        middle_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number_verified
        phone_mobile
        phone_number
        phone_other
        phone_home
        fax_number
        addressHome
        addressOther
        ssn
        dob
        dl_number
        createdAt
        updatedAt
        description
        premier
        cognito_userid
        owner
        companys {
          nextToken
        }
        accounts {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        messages {
          nextToken
        }
      }
    }
  }
`;
export const onDeletePersonCompany = /* GraphQL */ `
  subscription OnDeletePersonCompany {
    onDeletePersonCompany {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      company {
        id
        name
        premier
        email
        website
        phone
        phoneExt
        alertMessage
        IPCorp
        active
        updatedAt
        createdAt
        owner
        accounts {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        hq {
          id
          name
          createdAt
          updatedAt
          owner
          IPCorp
          active
        }
      }
      person {
        id
        given_name
        middle_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number_verified
        phone_mobile
        phone_number
        phone_other
        phone_home
        fax_number
        addressHome
        addressOther
        ssn
        dob
        dl_number
        createdAt
        updatedAt
        description
        premier
        cognito_userid
        owner
        companys {
          nextToken
        }
        accounts {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        messages {
          nextToken
        }
      }
    }
  }
`;
export const onCreatePersonAccount = /* GraphQL */ `
  subscription OnCreatePersonAccount {
    onCreatePersonAccount {
      id
      role
      title
      email
      business_email
      other_email
      ownership
      owner
      createdAt
      updatedAt
      esData
      esSync
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      person {
        id
        given_name
        middle_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number_verified
        phone_mobile
        phone_number
        phone_other
        phone_home
        fax_number
        addressHome
        addressOther
        ssn
        dob
        dl_number
        createdAt
        updatedAt
        description
        premier
        cognito_userid
        owner
        companys {
          nextToken
        }
        accounts {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        messages {
          nextToken
        }
      }
    }
  }
`;
export const onUpdatePersonAccount = /* GraphQL */ `
  subscription OnUpdatePersonAccount {
    onUpdatePersonAccount {
      id
      role
      title
      email
      business_email
      other_email
      ownership
      owner
      createdAt
      updatedAt
      esData
      esSync
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      person {
        id
        given_name
        middle_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number_verified
        phone_mobile
        phone_number
        phone_other
        phone_home
        fax_number
        addressHome
        addressOther
        ssn
        dob
        dl_number
        createdAt
        updatedAt
        description
        premier
        cognito_userid
        owner
        companys {
          nextToken
        }
        accounts {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        messages {
          nextToken
        }
      }
    }
  }
`;
export const onDeletePersonAccount = /* GraphQL */ `
  subscription OnDeletePersonAccount {
    onDeletePersonAccount {
      id
      role
      title
      email
      business_email
      other_email
      ownership
      owner
      createdAt
      updatedAt
      esData
      esSync
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      person {
        id
        given_name
        middle_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number_verified
        phone_mobile
        phone_number
        phone_other
        phone_home
        fax_number
        addressHome
        addressOther
        ssn
        dob
        dl_number
        createdAt
        updatedAt
        description
        premier
        cognito_userid
        owner
        companys {
          nextToken
        }
        accounts {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        messages {
          nextToken
        }
      }
    }
  }
`;
export const onCreateCaseAccount = /* GraphQL */ `
  subscription OnCreateCaseAccount {
    onCreateCaseAccount {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const onUpdateCaseAccount = /* GraphQL */ `
  subscription OnUpdateCaseAccount {
    onUpdateCaseAccount {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const onDeleteCaseAccount = /* GraphQL */ `
  subscription OnDeleteCaseAccount {
    onDeleteCaseAccount {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const onCreateCaseService = /* GraphQL */ `
  subscription OnCreateCaseService {
    onCreateCaseService {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const onUpdateCaseService = /* GraphQL */ `
  subscription OnUpdateCaseService {
    onUpdateCaseService {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const onDeleteCaseService = /* GraphQL */ `
  subscription OnDeleteCaseService {
    onDeleteCaseService {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const onCreateCaseProduct = /* GraphQL */ `
  subscription OnCreateCaseProduct {
    onCreateCaseProduct {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      product {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const onUpdateCaseProduct = /* GraphQL */ `
  subscription OnUpdateCaseProduct {
    onUpdateCaseProduct {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      product {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const onDeleteCaseProduct = /* GraphQL */ `
  subscription OnDeleteCaseProduct {
    onDeleteCaseProduct {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      product {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const onCreateCaseCompany = /* GraphQL */ `
  subscription OnCreateCaseCompany {
    onCreateCaseCompany {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      company {
        id
        name
        premier
        email
        website
        phone
        phoneExt
        alertMessage
        IPCorp
        active
        updatedAt
        createdAt
        owner
        accounts {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        hq {
          id
          name
          createdAt
          updatedAt
          owner
          IPCorp
          active
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const onUpdateCaseCompany = /* GraphQL */ `
  subscription OnUpdateCaseCompany {
    onUpdateCaseCompany {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      company {
        id
        name
        premier
        email
        website
        phone
        phoneExt
        alertMessage
        IPCorp
        active
        updatedAt
        createdAt
        owner
        accounts {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        hq {
          id
          name
          createdAt
          updatedAt
          owner
          IPCorp
          active
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const onDeleteCaseCompany = /* GraphQL */ `
  subscription OnDeleteCaseCompany {
    onDeleteCaseCompany {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      company {
        id
        name
        premier
        email
        website
        phone
        phoneExt
        alertMessage
        IPCorp
        active
        updatedAt
        createdAt
        owner
        accounts {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        hq {
          id
          name
          createdAt
          updatedAt
          owner
          IPCorp
          active
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const onCreateCaseSalesRep = /* GraphQL */ `
  subscription OnCreateCaseSalesRep {
    onCreateCaseSalesRep {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      salesrep {
        id
        given_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number
        phone_number_verified
        addressMailing
        description
        premier
        cognito_userid
        createdAt
        updatedAt
        owner
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const onUpdateCaseSalesRep = /* GraphQL */ `
  subscription OnUpdateCaseSalesRep {
    onUpdateCaseSalesRep {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      salesrep {
        id
        given_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number
        phone_number_verified
        addressMailing
        description
        premier
        cognito_userid
        createdAt
        updatedAt
        owner
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const onDeleteCaseSalesRep = /* GraphQL */ `
  subscription OnDeleteCaseSalesRep {
    onDeleteCaseSalesRep {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      salesrep {
        id
        given_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number
        phone_number_verified
        addressMailing
        description
        premier
        cognito_userid
        createdAt
        updatedAt
        owner
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const onCreateTaskAccount = /* GraphQL */ `
  subscription OnCreateTaskAccount {
    onCreateTaskAccount {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const onUpdateTaskAccount = /* GraphQL */ `
  subscription OnUpdateTaskAccount {
    onUpdateTaskAccount {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const onDeleteTaskAccount = /* GraphQL */ `
  subscription OnDeleteTaskAccount {
    onDeleteTaskAccount {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const onCreateTaskService = /* GraphQL */ `
  subscription OnCreateTaskService {
    onCreateTaskService {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const onUpdateTaskService = /* GraphQL */ `
  subscription OnUpdateTaskService {
    onUpdateTaskService {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const onDeleteTaskService = /* GraphQL */ `
  subscription OnDeleteTaskService {
    onDeleteTaskService {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const onCreateTaskProduct = /* GraphQL */ `
  subscription OnCreateTaskProduct {
    onCreateTaskProduct {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      product {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const onUpdateTaskProduct = /* GraphQL */ `
  subscription OnUpdateTaskProduct {
    onUpdateTaskProduct {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      product {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const onDeleteTaskProduct = /* GraphQL */ `
  subscription OnDeleteTaskProduct {
    onDeleteTaskProduct {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      product {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const onCreateTaskCompany = /* GraphQL */ `
  subscription OnCreateTaskCompany {
    onCreateTaskCompany {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      company {
        id
        name
        premier
        email
        website
        phone
        phoneExt
        alertMessage
        IPCorp
        active
        updatedAt
        createdAt
        owner
        accounts {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        hq {
          id
          name
          createdAt
          updatedAt
          owner
          IPCorp
          active
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const onUpdateTaskCompany = /* GraphQL */ `
  subscription OnUpdateTaskCompany {
    onUpdateTaskCompany {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      company {
        id
        name
        premier
        email
        website
        phone
        phoneExt
        alertMessage
        IPCorp
        active
        updatedAt
        createdAt
        owner
        accounts {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        hq {
          id
          name
          createdAt
          updatedAt
          owner
          IPCorp
          active
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const onDeleteTaskCompany = /* GraphQL */ `
  subscription OnDeleteTaskCompany {
    onDeleteTaskCompany {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      company {
        id
        name
        premier
        email
        website
        phone
        phoneExt
        alertMessage
        IPCorp
        active
        updatedAt
        createdAt
        owner
        accounts {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        hq {
          id
          name
          createdAt
          updatedAt
          owner
          IPCorp
          active
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const onCreateTaskSalesRep = /* GraphQL */ `
  subscription OnCreateTaskSalesRep {
    onCreateTaskSalesRep {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      salesrep {
        id
        given_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number
        phone_number_verified
        addressMailing
        description
        premier
        cognito_userid
        createdAt
        updatedAt
        owner
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const onUpdateTaskSalesRep = /* GraphQL */ `
  subscription OnUpdateTaskSalesRep {
    onUpdateTaskSalesRep {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      salesrep {
        id
        given_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number
        phone_number_verified
        addressMailing
        description
        premier
        cognito_userid
        createdAt
        updatedAt
        owner
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const onDeleteTaskSalesRep = /* GraphQL */ `
  subscription OnDeleteTaskSalesRep {
    onDeleteTaskSalesRep {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      salesrep {
        id
        given_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number
        phone_number_verified
        addressMailing
        description
        premier
        cognito_userid
        createdAt
        updatedAt
        owner
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const onCreateCase = /* GraphQL */ `
  subscription OnCreateCase {
    onCreateCase {
      id
      name
      subject
      status
      internal
      isCompleteInOrder
      origin
      type
      alertMessage
      dateDue
      closedDate
      priority
      quickNote
      createdAt
      updatedAt
      owner
      rushReason
      isSystemCreated
      person {
        id
        given_name
        middle_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number_verified
        phone_mobile
        phone_number
        phone_other
        phone_home
        fax_number
        addressHome
        addressOther
        ssn
        dob
        dl_number
        createdAt
        updatedAt
        description
        premier
        cognito_userid
        owner
        companys {
          nextToken
        }
        accounts {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        messages {
          nextToken
        }
      }
      accounts {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      services {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      products {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      companies {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      salesreps {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      template {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        dateDue
        priority
        createdAt
        updatedAt
        owner
        hasWorkflow
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
      }
      caseLinks {
        items {
          id
          reason
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      team {
        id
        name
        cognito_groupid
        owner
        createdAt
        default
        updatedAt
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        users {
          nextToken
        }
      }
      tasks {
        items {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        nextToken
      }
      messages {
        items {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      caseDrafts {
        items {
          id
          subject
          from
          to
          cc
          bcc
          body
          messageCaseId
          internal
          owner
          draftType
          replyToMessageId
          createdAt
          updatedAt
        }
        nextToken
      }
      notes {
        items {
          id
          note
          internal
          owner
          createdAt
          updatedAt
          atMentions
        }
        nextToken
      }
    }
  }
`;
export const onUpdateCase = /* GraphQL */ `
  subscription OnUpdateCase {
    onUpdateCase {
      id
      name
      subject
      status
      internal
      isCompleteInOrder
      origin
      type
      alertMessage
      dateDue
      closedDate
      priority
      quickNote
      createdAt
      updatedAt
      owner
      rushReason
      isSystemCreated
      person {
        id
        given_name
        middle_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number_verified
        phone_mobile
        phone_number
        phone_other
        phone_home
        fax_number
        addressHome
        addressOther
        ssn
        dob
        dl_number
        createdAt
        updatedAt
        description
        premier
        cognito_userid
        owner
        companys {
          nextToken
        }
        accounts {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        messages {
          nextToken
        }
      }
      accounts {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      services {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      products {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      companies {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      salesreps {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      template {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        dateDue
        priority
        createdAt
        updatedAt
        owner
        hasWorkflow
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
      }
      caseLinks {
        items {
          id
          reason
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      team {
        id
        name
        cognito_groupid
        owner
        createdAt
        default
        updatedAt
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        users {
          nextToken
        }
      }
      tasks {
        items {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        nextToken
      }
      messages {
        items {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      caseDrafts {
        items {
          id
          subject
          from
          to
          cc
          bcc
          body
          messageCaseId
          internal
          owner
          draftType
          replyToMessageId
          createdAt
          updatedAt
        }
        nextToken
      }
      notes {
        items {
          id
          note
          internal
          owner
          createdAt
          updatedAt
          atMentions
        }
        nextToken
      }
    }
  }
`;
export const onDeleteCase = /* GraphQL */ `
  subscription OnDeleteCase {
    onDeleteCase {
      id
      name
      subject
      status
      internal
      isCompleteInOrder
      origin
      type
      alertMessage
      dateDue
      closedDate
      priority
      quickNote
      createdAt
      updatedAt
      owner
      rushReason
      isSystemCreated
      person {
        id
        given_name
        middle_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number_verified
        phone_mobile
        phone_number
        phone_other
        phone_home
        fax_number
        addressHome
        addressOther
        ssn
        dob
        dl_number
        createdAt
        updatedAt
        description
        premier
        cognito_userid
        owner
        companys {
          nextToken
        }
        accounts {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        messages {
          nextToken
        }
      }
      accounts {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      services {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      products {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      companies {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      salesreps {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      template {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        dateDue
        priority
        createdAt
        updatedAt
        owner
        hasWorkflow
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
      }
      caseLinks {
        items {
          id
          reason
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      team {
        id
        name
        cognito_groupid
        owner
        createdAt
        default
        updatedAt
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        users {
          nextToken
        }
      }
      tasks {
        items {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        nextToken
      }
      messages {
        items {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      caseDrafts {
        items {
          id
          subject
          from
          to
          cc
          bcc
          body
          messageCaseId
          internal
          owner
          draftType
          replyToMessageId
          createdAt
          updatedAt
        }
        nextToken
      }
      notes {
        items {
          id
          note
          internal
          owner
          createdAt
          updatedAt
          atMentions
        }
        nextToken
      }
    }
  }
`;
export const onCreateAttachment = /* GraphQL */ `
  subscription OnCreateAttachment {
    onCreateAttachment {
      id
      name
      type
      description
      s3Path
      isDeleted
      internal
      owner
      createdAt
      updatedAt
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onUpdateAttachment = /* GraphQL */ `
  subscription OnUpdateAttachment {
    onUpdateAttachment {
      id
      name
      type
      description
      s3Path
      isDeleted
      internal
      owner
      createdAt
      updatedAt
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onDeleteAttachment = /* GraphQL */ `
  subscription OnDeleteAttachment {
    onDeleteAttachment {
      id
      name
      type
      description
      s3Path
      isDeleted
      internal
      owner
      createdAt
      updatedAt
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onCreateRelation = /* GraphQL */ `
  subscription OnCreateRelation {
    onCreateRelation {
      id
      fromModelType
      toModelType
      createdAt
      updatedAt
      esData
      esSync
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      attachment {
        id
        name
        type
        description
        s3Path
        isDeleted
        internal
        owner
        createdAt
        updatedAt
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
      message {
        id
        sesMessageId
        subject
        from
        to
        cc
        bcc
        body
        internal
        messageCaseId
        replyToMessageId
        outgoingFlag
        attachmentOptions
        messageAttachmentId
        bounces
        origin
        createdAt
        updatedAt
        owner
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      comment {
        id
        comment
        internal
        createdAt
        updatedAt
        owner
        atMentions
        service {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        task {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        message {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        parentComment {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        comments {
          nextToken
        }
        note {
          id
          note
          internal
          owner
          createdAt
          updatedAt
          atMentions
        }
      }
      note {
        id
        note
        internal
        owner
        createdAt
        updatedAt
        atMentions
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const onUpdateRelation = /* GraphQL */ `
  subscription OnUpdateRelation {
    onUpdateRelation {
      id
      fromModelType
      toModelType
      createdAt
      updatedAt
      esData
      esSync
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      attachment {
        id
        name
        type
        description
        s3Path
        isDeleted
        internal
        owner
        createdAt
        updatedAt
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
      message {
        id
        sesMessageId
        subject
        from
        to
        cc
        bcc
        body
        internal
        messageCaseId
        replyToMessageId
        outgoingFlag
        attachmentOptions
        messageAttachmentId
        bounces
        origin
        createdAt
        updatedAt
        owner
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      comment {
        id
        comment
        internal
        createdAt
        updatedAt
        owner
        atMentions
        service {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        task {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        message {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        parentComment {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        comments {
          nextToken
        }
        note {
          id
          note
          internal
          owner
          createdAt
          updatedAt
          atMentions
        }
      }
      note {
        id
        note
        internal
        owner
        createdAt
        updatedAt
        atMentions
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const onDeleteRelation = /* GraphQL */ `
  subscription OnDeleteRelation {
    onDeleteRelation {
      id
      fromModelType
      toModelType
      createdAt
      updatedAt
      esData
      esSync
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      attachment {
        id
        name
        type
        description
        s3Path
        isDeleted
        internal
        owner
        createdAt
        updatedAt
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
      message {
        id
        sesMessageId
        subject
        from
        to
        cc
        bcc
        body
        internal
        messageCaseId
        replyToMessageId
        outgoingFlag
        attachmentOptions
        messageAttachmentId
        bounces
        origin
        createdAt
        updatedAt
        owner
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      comment {
        id
        comment
        internal
        createdAt
        updatedAt
        owner
        atMentions
        service {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        task {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        message {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        parentComment {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        comments {
          nextToken
        }
        note {
          id
          note
          internal
          owner
          createdAt
          updatedAt
          atMentions
        }
      }
      note {
        id
        note
        internal
        owner
        createdAt
        updatedAt
        atMentions
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const onCreateCaseTemplate = /* GraphQL */ `
  subscription OnCreateCaseTemplate {
    onCreateCaseTemplate {
      id
      name
      subject
      status
      internal
      isCompleteInOrder
      origin
      type
      dateDue
      priority
      createdAt
      updatedAt
      owner
      hasWorkflow
      cases {
        items {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      team {
        id
        name
        cognito_groupid
        owner
        createdAt
        default
        updatedAt
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        users {
          nextToken
        }
      }
      tasks {
        items {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        nextToken
      }
    }
  }
`;
export const onUpdateCaseTemplate = /* GraphQL */ `
  subscription OnUpdateCaseTemplate {
    onUpdateCaseTemplate {
      id
      name
      subject
      status
      internal
      isCompleteInOrder
      origin
      type
      dateDue
      priority
      createdAt
      updatedAt
      owner
      hasWorkflow
      cases {
        items {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      team {
        id
        name
        cognito_groupid
        owner
        createdAt
        default
        updatedAt
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        users {
          nextToken
        }
      }
      tasks {
        items {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        nextToken
      }
    }
  }
`;
export const onDeleteCaseTemplate = /* GraphQL */ `
  subscription OnDeleteCaseTemplate {
    onDeleteCaseTemplate {
      id
      name
      subject
      status
      internal
      isCompleteInOrder
      origin
      type
      dateDue
      priority
      createdAt
      updatedAt
      owner
      hasWorkflow
      cases {
        items {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      team {
        id
        name
        cognito_groupid
        owner
        createdAt
        default
        updatedAt
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        users {
          nextToken
        }
      }
      tasks {
        items {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        nextToken
      }
    }
  }
`;
export const onCreateCaseTemplateTask = /* GraphQL */ `
  subscription OnCreateCaseTemplateTask {
    onCreateCaseTemplateTask {
      id
      order
      type
      dateDue
      subject
      internal
      createdAt
      updatedAt
      owner
      priority
      status
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onUpdateCaseTemplateTask = /* GraphQL */ `
  subscription OnUpdateCaseTemplateTask {
    onUpdateCaseTemplateTask {
      id
      order
      type
      dateDue
      subject
      internal
      createdAt
      updatedAt
      owner
      priority
      status
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onDeleteCaseTemplateTask = /* GraphQL */ `
  subscription OnDeleteCaseTemplateTask {
    onDeleteCaseTemplateTask {
      id
      order
      type
      dateDue
      subject
      internal
      createdAt
      updatedAt
      owner
      priority
      status
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onCreateCaseLink = /* GraphQL */ `
  subscription OnCreateCaseLink {
    onCreateCaseLink {
      id
      reason
      owner
      createdAt
      updatedAt
      esData
      esSync
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      linkCase {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const onUpdateCaseLink = /* GraphQL */ `
  subscription OnUpdateCaseLink {
    onUpdateCaseLink {
      id
      reason
      owner
      createdAt
      updatedAt
      esData
      esSync
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      linkCase {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const onDeleteCaseLink = /* GraphQL */ `
  subscription OnDeleteCaseLink {
    onDeleteCaseLink {
      id
      reason
      owner
      createdAt
      updatedAt
      esData
      esSync
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      linkCase {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const onCreateUser = /* GraphQL */ `
  subscription OnCreateUser {
    onCreateUser {
      id
      email
      given_name
      family_name
      middle_name
      nickname
      picture
      gender
      birthdate
      zoneinfo
      phone_number
      address
      source
      IPCorp
      internal
      TaskSaveAsTemplate
      CaseSaveAsTemplate
      createdAt
      updatedAt
      cogUsername
      cogUserAttributes {
        Name
        Value
      }
      cogUserCreateDate
      cogUserLastModifiedDate
      cogEnabled
      cogUserStatus
      cogEmailVerified
      cogMFAOptions {
        DeliveryMedium
        AttributeName
      }
      cogPreferredMfaSetting
      cogUserMFASettingList
      owner
      services {
        items {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        nextToken
      }
      cases {
        items {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      teams {
        items {
          id
          role
          cognito_userid
          cognito_groupid
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        nextToken
      }
      messages {
        items {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      caseDrafts {
        items {
          id
          subject
          from
          to
          cc
          bcc
          body
          messageCaseId
          internal
          owner
          draftType
          replyToMessageId
          createdAt
          updatedAt
        }
        nextToken
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
      notes {
        items {
          id
          note
          internal
          owner
          createdAt
          updatedAt
          atMentions
        }
        nextToken
      }
      changes {
        items {
          id
          owner
          createdAt
          updatedAt
          action
          modelId
          modelName
          change
        }
        nextToken
      }
      alerts {
        items {
          id
          owner
          createdAt
          updatedAt
          type
          subject
          body
          link
          ttl
          level
          status
        }
        nextToken
      }
    }
  }
`;
export const onUpdateUser = /* GraphQL */ `
  subscription OnUpdateUser {
    onUpdateUser {
      id
      email
      given_name
      family_name
      middle_name
      nickname
      picture
      gender
      birthdate
      zoneinfo
      phone_number
      address
      source
      IPCorp
      internal
      TaskSaveAsTemplate
      CaseSaveAsTemplate
      createdAt
      updatedAt
      cogUsername
      cogUserAttributes {
        Name
        Value
      }
      cogUserCreateDate
      cogUserLastModifiedDate
      cogEnabled
      cogUserStatus
      cogEmailVerified
      cogMFAOptions {
        DeliveryMedium
        AttributeName
      }
      cogPreferredMfaSetting
      cogUserMFASettingList
      owner
      services {
        items {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        nextToken
      }
      cases {
        items {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      teams {
        items {
          id
          role
          cognito_userid
          cognito_groupid
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        nextToken
      }
      messages {
        items {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      caseDrafts {
        items {
          id
          subject
          from
          to
          cc
          bcc
          body
          messageCaseId
          internal
          owner
          draftType
          replyToMessageId
          createdAt
          updatedAt
        }
        nextToken
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
      notes {
        items {
          id
          note
          internal
          owner
          createdAt
          updatedAt
          atMentions
        }
        nextToken
      }
      changes {
        items {
          id
          owner
          createdAt
          updatedAt
          action
          modelId
          modelName
          change
        }
        nextToken
      }
      alerts {
        items {
          id
          owner
          createdAt
          updatedAt
          type
          subject
          body
          link
          ttl
          level
          status
        }
        nextToken
      }
    }
  }
`;
export const onDeleteUser = /* GraphQL */ `
  subscription OnDeleteUser {
    onDeleteUser {
      id
      email
      given_name
      family_name
      middle_name
      nickname
      picture
      gender
      birthdate
      zoneinfo
      phone_number
      address
      source
      IPCorp
      internal
      TaskSaveAsTemplate
      CaseSaveAsTemplate
      createdAt
      updatedAt
      cogUsername
      cogUserAttributes {
        Name
        Value
      }
      cogUserCreateDate
      cogUserLastModifiedDate
      cogEnabled
      cogUserStatus
      cogEmailVerified
      cogMFAOptions {
        DeliveryMedium
        AttributeName
      }
      cogPreferredMfaSetting
      cogUserMFASettingList
      owner
      services {
        items {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        nextToken
      }
      cases {
        items {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      teams {
        items {
          id
          role
          cognito_userid
          cognito_groupid
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        nextToken
      }
      messages {
        items {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      caseDrafts {
        items {
          id
          subject
          from
          to
          cc
          bcc
          body
          messageCaseId
          internal
          owner
          draftType
          replyToMessageId
          createdAt
          updatedAt
        }
        nextToken
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
      notes {
        items {
          id
          note
          internal
          owner
          createdAt
          updatedAt
          atMentions
        }
        nextToken
      }
      changes {
        items {
          id
          owner
          createdAt
          updatedAt
          action
          modelId
          modelName
          change
        }
        nextToken
      }
      alerts {
        items {
          id
          owner
          createdAt
          updatedAt
          type
          subject
          body
          link
          ttl
          level
          status
        }
        nextToken
      }
    }
  }
`;
export const onCreateHq = /* GraphQL */ `
  subscription OnCreateHq {
    onCreateHQ {
      id
      name
      createdAt
      updatedAt
      owner
      IPCorp
      active
      companies {
        items {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onUpdateHq = /* GraphQL */ `
  subscription OnUpdateHq {
    onUpdateHQ {
      id
      name
      createdAt
      updatedAt
      owner
      IPCorp
      active
      companies {
        items {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onDeleteHq = /* GraphQL */ `
  subscription OnDeleteHq {
    onDeleteHQ {
      id
      name
      createdAt
      updatedAt
      owner
      IPCorp
      active
      companies {
        items {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onCreateSalesOffice = /* GraphQL */ `
  subscription OnCreateSalesOffice {
    onCreateSalesOffice {
      id
      name
      active
      owner
      createdAt
      updatedAt
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onUpdateSalesOffice = /* GraphQL */ `
  subscription OnUpdateSalesOffice {
    onUpdateSalesOffice {
      id
      name
      active
      owner
      createdAt
      updatedAt
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onDeleteSalesOffice = /* GraphQL */ `
  subscription OnDeleteSalesOffice {
    onDeleteSalesOffice {
      id
      name
      active
      owner
      createdAt
      updatedAt
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onCreateTeam = /* GraphQL */ `
  subscription OnCreateTeam {
    onCreateTeam {
      id
      name
      cognito_groupid
      owner
      createdAt
      default
      updatedAt
      cases {
        items {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      users {
        items {
          id
          role
          cognito_userid
          cognito_groupid
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
    }
  }
`;
export const onUpdateTeam = /* GraphQL */ `
  subscription OnUpdateTeam {
    onUpdateTeam {
      id
      name
      cognito_groupid
      owner
      createdAt
      default
      updatedAt
      cases {
        items {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      users {
        items {
          id
          role
          cognito_userid
          cognito_groupid
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
    }
  }
`;
export const onDeleteTeam = /* GraphQL */ `
  subscription OnDeleteTeam {
    onDeleteTeam {
      id
      name
      cognito_groupid
      owner
      createdAt
      default
      updatedAt
      cases {
        items {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      users {
        items {
          id
          role
          cognito_userid
          cognito_groupid
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
    }
  }
`;
export const onCreateTeamUser = /* GraphQL */ `
  subscription OnCreateTeamUser {
    onCreateTeamUser {
      id
      role
      cognito_userid
      cognito_groupid
      owner
      createdAt
      updatedAt
      esData
      esSync
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      team {
        id
        name
        cognito_groupid
        owner
        createdAt
        default
        updatedAt
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        users {
          nextToken
        }
      }
    }
  }
`;
export const onUpdateTeamUser = /* GraphQL */ `
  subscription OnUpdateTeamUser {
    onUpdateTeamUser {
      id
      role
      cognito_userid
      cognito_groupid
      owner
      createdAt
      updatedAt
      esData
      esSync
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      team {
        id
        name
        cognito_groupid
        owner
        createdAt
        default
        updatedAt
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        users {
          nextToken
        }
      }
    }
  }
`;
export const onDeleteTeamUser = /* GraphQL */ `
  subscription OnDeleteTeamUser {
    onDeleteTeamUser {
      id
      role
      cognito_userid
      cognito_groupid
      owner
      createdAt
      updatedAt
      esData
      esSync
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      team {
        id
        name
        cognito_groupid
        owner
        createdAt
        default
        updatedAt
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        users {
          nextToken
        }
      }
    }
  }
`;
export const onCreateTask = /* GraphQL */ `
  subscription OnCreateTask {
    onCreateTask {
      id
      isTemplate
      isAvailable
      isCompleteInOrder
      type
      dateDue
      subject
      internal
      owner
      group
      order
      createdAt
      updatedAt
      priority
      status
      dateCompleted
      quickNote
      isSystemCreated
      hasWorkflow
      skipAlert
      accounts {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      services {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      products {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      companies {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      salesreps {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      caseTemplate {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        dateDue
        priority
        createdAt
        updatedAt
        owner
        hasWorkflow
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      taskTemplate {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
      steps {
        items {
          id
          title
          description
          isAvailable
          order
          status
          owner
          createdAt
          updatedAt
        }
        nextToken
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
    }
  }
`;
export const onUpdateTask = /* GraphQL */ `
  subscription OnUpdateTask {
    onUpdateTask {
      id
      isTemplate
      isAvailable
      isCompleteInOrder
      type
      dateDue
      subject
      internal
      owner
      group
      order
      createdAt
      updatedAt
      priority
      status
      dateCompleted
      quickNote
      isSystemCreated
      hasWorkflow
      skipAlert
      accounts {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      services {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      products {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      companies {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      salesreps {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      caseTemplate {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        dateDue
        priority
        createdAt
        updatedAt
        owner
        hasWorkflow
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      taskTemplate {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
      steps {
        items {
          id
          title
          description
          isAvailable
          order
          status
          owner
          createdAt
          updatedAt
        }
        nextToken
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
    }
  }
`;
export const onDeleteTask = /* GraphQL */ `
  subscription OnDeleteTask {
    onDeleteTask {
      id
      isTemplate
      isAvailable
      isCompleteInOrder
      type
      dateDue
      subject
      internal
      owner
      group
      order
      createdAt
      updatedAt
      priority
      status
      dateCompleted
      quickNote
      isSystemCreated
      hasWorkflow
      skipAlert
      accounts {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      services {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      products {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      companies {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      salesreps {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      caseTemplate {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        dateDue
        priority
        createdAt
        updatedAt
        owner
        hasWorkflow
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      taskTemplate {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
      steps {
        items {
          id
          title
          description
          isAvailable
          order
          status
          owner
          createdAt
          updatedAt
        }
        nextToken
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
    }
  }
`;
export const onCreateTaskStep = /* GraphQL */ `
  subscription OnCreateTaskStep {
    onCreateTaskStep {
      id
      title
      description
      isAvailable
      order
      status
      owner
      createdAt
      updatedAt
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const onUpdateTaskStep = /* GraphQL */ `
  subscription OnUpdateTaskStep {
    onUpdateTaskStep {
      id
      title
      description
      isAvailable
      order
      status
      owner
      createdAt
      updatedAt
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const onDeleteTaskStep = /* GraphQL */ `
  subscription OnDeleteTaskStep {
    onDeleteTaskStep {
      id
      title
      description
      isAvailable
      order
      status
      owner
      createdAt
      updatedAt
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const onCreateMessage = /* GraphQL */ `
  subscription OnCreateMessage {
    onCreateMessage {
      id
      sesMessageId
      subject
      from
      to
      cc
      bcc
      body
      internal
      messageCaseId
      replyToMessageId
      outgoingFlag
      attachmentOptions
      messageAttachmentId
      bounces
      origin
      createdAt
      updatedAt
      owner
      person {
        id
        given_name
        middle_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number_verified
        phone_mobile
        phone_number
        phone_other
        phone_home
        fax_number
        addressHome
        addressOther
        ssn
        dob
        dl_number
        createdAt
        updatedAt
        description
        premier
        cognito_userid
        owner
        companys {
          nextToken
        }
        accounts {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        messages {
          nextToken
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
    }
  }
`;
export const onUpdateMessage = /* GraphQL */ `
  subscription OnUpdateMessage {
    onUpdateMessage {
      id
      sesMessageId
      subject
      from
      to
      cc
      bcc
      body
      internal
      messageCaseId
      replyToMessageId
      outgoingFlag
      attachmentOptions
      messageAttachmentId
      bounces
      origin
      createdAt
      updatedAt
      owner
      person {
        id
        given_name
        middle_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number_verified
        phone_mobile
        phone_number
        phone_other
        phone_home
        fax_number
        addressHome
        addressOther
        ssn
        dob
        dl_number
        createdAt
        updatedAt
        description
        premier
        cognito_userid
        owner
        companys {
          nextToken
        }
        accounts {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        messages {
          nextToken
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
    }
  }
`;
export const onDeleteMessage = /* GraphQL */ `
  subscription OnDeleteMessage {
    onDeleteMessage {
      id
      sesMessageId
      subject
      from
      to
      cc
      bcc
      body
      internal
      messageCaseId
      replyToMessageId
      outgoingFlag
      attachmentOptions
      messageAttachmentId
      bounces
      origin
      createdAt
      updatedAt
      owner
      person {
        id
        given_name
        middle_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number_verified
        phone_mobile
        phone_number
        phone_other
        phone_home
        fax_number
        addressHome
        addressOther
        ssn
        dob
        dl_number
        createdAt
        updatedAt
        description
        premier
        cognito_userid
        owner
        companys {
          nextToken
        }
        accounts {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        messages {
          nextToken
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
    }
  }
`;
export const onCreateCaseDraft = /* GraphQL */ `
  subscription OnCreateCaseDraft {
    onCreateCaseDraft {
      id
      subject
      from
      to
      cc
      bcc
      body
      messageCaseId
      internal
      owner
      draftType
      replyToMessageId
      createdAt
      updatedAt
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onUpdateCaseDraft = /* GraphQL */ `
  subscription OnUpdateCaseDraft {
    onUpdateCaseDraft {
      id
      subject
      from
      to
      cc
      bcc
      body
      messageCaseId
      internal
      owner
      draftType
      replyToMessageId
      createdAt
      updatedAt
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onDeleteCaseDraft = /* GraphQL */ `
  subscription OnDeleteCaseDraft {
    onDeleteCaseDraft {
      id
      subject
      from
      to
      cc
      bcc
      body
      messageCaseId
      internal
      owner
      draftType
      replyToMessageId
      createdAt
      updatedAt
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onCreateMessageOutgoing = /* GraphQL */ `
  subscription OnCreateMessageOutgoing {
    onCreateMessageOutgoing {
      id
      replyToMessageId
      subject
      from
      to
      cc
      bcc
      body
      internal
      attachmentOptions
      messageCaseId
      messageUserId
      outgoingFlag
      messageAttachmentId
      createdAt
      updatedAt
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onUpdateMessageOutgoing = /* GraphQL */ `
  subscription OnUpdateMessageOutgoing {
    onUpdateMessageOutgoing {
      id
      replyToMessageId
      subject
      from
      to
      cc
      bcc
      body
      internal
      attachmentOptions
      messageCaseId
      messageUserId
      outgoingFlag
      messageAttachmentId
      createdAt
      updatedAt
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onDeleteMessageOutgoing = /* GraphQL */ `
  subscription OnDeleteMessageOutgoing {
    onDeleteMessageOutgoing {
      id
      replyToMessageId
      subject
      from
      to
      cc
      bcc
      body
      internal
      attachmentOptions
      messageCaseId
      messageUserId
      outgoingFlag
      messageAttachmentId
      createdAt
      updatedAt
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onCreateMessageAttachment = /* GraphQL */ `
  subscription OnCreateMessageAttachment {
    onCreateMessageAttachment {
      id
      messageId
      attachmentId
      internal
      createdAt
      updatedAt
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onUpdateMessageAttachment = /* GraphQL */ `
  subscription OnUpdateMessageAttachment {
    onUpdateMessageAttachment {
      id
      messageId
      attachmentId
      internal
      createdAt
      updatedAt
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onDeleteMessageAttachment = /* GraphQL */ `
  subscription OnDeleteMessageAttachment {
    onDeleteMessageAttachment {
      id
      messageId
      attachmentId
      internal
      createdAt
      updatedAt
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onCreateComment = /* GraphQL */ `
  subscription OnCreateComment {
    onCreateComment {
      id
      comment
      internal
      createdAt
      updatedAt
      owner
      atMentions
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
      message {
        id
        sesMessageId
        subject
        from
        to
        cc
        bcc
        body
        internal
        messageCaseId
        replyToMessageId
        outgoingFlag
        attachmentOptions
        messageAttachmentId
        bounces
        origin
        createdAt
        updatedAt
        owner
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      parentComment {
        id
        comment
        internal
        createdAt
        updatedAt
        owner
        atMentions
        service {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        task {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        message {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        parentComment {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        comments {
          nextToken
        }
        note {
          id
          note
          internal
          owner
          createdAt
          updatedAt
          atMentions
        }
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
      note {
        id
        note
        internal
        owner
        createdAt
        updatedAt
        atMentions
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const onUpdateComment = /* GraphQL */ `
  subscription OnUpdateComment {
    onUpdateComment {
      id
      comment
      internal
      createdAt
      updatedAt
      owner
      atMentions
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
      message {
        id
        sesMessageId
        subject
        from
        to
        cc
        bcc
        body
        internal
        messageCaseId
        replyToMessageId
        outgoingFlag
        attachmentOptions
        messageAttachmentId
        bounces
        origin
        createdAt
        updatedAt
        owner
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      parentComment {
        id
        comment
        internal
        createdAt
        updatedAt
        owner
        atMentions
        service {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        task {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        message {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        parentComment {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        comments {
          nextToken
        }
        note {
          id
          note
          internal
          owner
          createdAt
          updatedAt
          atMentions
        }
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
      note {
        id
        note
        internal
        owner
        createdAt
        updatedAt
        atMentions
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const onDeleteComment = /* GraphQL */ `
  subscription OnDeleteComment {
    onDeleteComment {
      id
      comment
      internal
      createdAt
      updatedAt
      owner
      atMentions
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
      message {
        id
        sesMessageId
        subject
        from
        to
        cc
        bcc
        body
        internal
        messageCaseId
        replyToMessageId
        outgoingFlag
        attachmentOptions
        messageAttachmentId
        bounces
        origin
        createdAt
        updatedAt
        owner
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      parentComment {
        id
        comment
        internal
        createdAt
        updatedAt
        owner
        atMentions
        service {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        task {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        message {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        parentComment {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        comments {
          nextToken
        }
        note {
          id
          note
          internal
          owner
          createdAt
          updatedAt
          atMentions
        }
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
      note {
        id
        note
        internal
        owner
        createdAt
        updatedAt
        atMentions
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const onCreateNote = /* GraphQL */ `
  subscription OnCreateNote {
    onCreateNote {
      id
      note
      internal
      owner
      createdAt
      updatedAt
      atMentions
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
    }
  }
`;
export const onUpdateNote = /* GraphQL */ `
  subscription OnUpdateNote {
    onUpdateNote {
      id
      note
      internal
      owner
      createdAt
      updatedAt
      atMentions
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
    }
  }
`;
export const onDeleteNote = /* GraphQL */ `
  subscription OnDeleteNote {
    onDeleteNote {
      id
      note
      internal
      owner
      createdAt
      updatedAt
      atMentions
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
    }
  }
`;
export const onCreateChange = /* GraphQL */ `
  subscription OnCreateChange {
    onCreateChange {
      id
      owner
      createdAt
      updatedAt
      action
      modelId
      modelName
      change
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onUpdateChange = /* GraphQL */ `
  subscription OnUpdateChange {
    onUpdateChange {
      id
      owner
      createdAt
      updatedAt
      action
      modelId
      modelName
      change
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onDeleteChange = /* GraphQL */ `
  subscription OnDeleteChange {
    onDeleteChange {
      id
      owner
      createdAt
      updatedAt
      action
      modelId
      modelName
      change
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onCreateAlert = /* GraphQL */ `
  subscription OnCreateAlert {
    onCreateAlert {
      id
      owner
      createdAt
      updatedAt
      type
      subject
      body
      link
      ttl
      level
      status
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onUpdateAlert = /* GraphQL */ `
  subscription OnUpdateAlert {
    onUpdateAlert {
      id
      owner
      createdAt
      updatedAt
      type
      subject
      body
      link
      ttl
      level
      status
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const onDeleteAlert = /* GraphQL */ `
  subscription OnDeleteAlert {
    onDeleteAlert {
      id
      owner
      createdAt
      updatedAt
      type
      subject
      body
      link
      ttl
      level
      status
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
